import './fieldLabel.scoped.scss'
import { ReactNode } from "react"

export interface FieldLabelProps {
  label: string | ReactNode
  hint?: string
}

/** The label above a form field */
export const FieldLabel = (props: FieldLabelProps) => {
  if (!props.hint) {
    return <span className="form-label">{props.label}</span>
  }

  return (
    <span className="form-label column gap1">
      <span>{props.label}</span>
      <span className="field-hint">{props.hint}</span>
    </span>
  )
}
